import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { waileaConfig } from "./data";

export default function WaileaPage() {
  return <CityPageTemplate config={waileaConfig} />;
}